import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faClipboardList, faCogs, faFileInvoiceDollar,faChartBar,faUserTie, faHouseMedical, faPersonBooth,faKey, faUserShield, faTachometerAlt, faPercentage, faBoxArchive, faCashRegister } from '@fortawesome/free-solid-svg-icons';
import '../styles/LandingPage.css'; // Add styles here
import { useAuth } from '../hooks/useAuth';

const LandingPage = () => {
  const {rolePermissions } = useAuth();

function MyLink (props) { 
  if(rolePermissions[props.path]?.View === 'true') {
   return (
  <Link to={props.path} className="link-card">
    <FontAwesomeIcon icon={props.iconname} size="3x" className="icon"/><p>{props.name}</p>
  </Link>);
  }
  //return <div></div>;
};


  return (
    <div className="landing-page">
      <div className="links-container">
        <MyLink path="/medical-reports-dashboard" iconname={faClipboardList} name="Medical Reports"/>
        <MyLink path="/admin-dashboard" iconname={faTachometerAlt} name="Admin Dashboard"/>
        <MyLink path="/admin-landing" iconname={faUserShield} name="Admin"/>
        <MyLink path="/sales-transactions" iconname={faFileInvoiceDollar} name="Sales Transactions"/>
        <MyLink path="/sales-form" iconname={faFileInvoiceDollar} name="Sales Form"/>
        <MyLink path="/sales-queue" iconname={faClipboardList} name="Sales Queue"/>
        <MyLink path="/cash-register" iconname={faCashRegister} name="Cash Register"/>
        <MyLink path="/customer-invoice" iconname={faFileInvoiceDollar} name="Customer Invoice"/>
        <MyLink path="/doctor-sales-summary" iconname={faFileInvoiceDollar} name="Doctor Sales"/>
        <MyLink path="/doctor-commission-config" iconname={faPercentage} name="Doctor Commission Config"/>
        <MyLink path="/customer-aging-summary" iconname={faChartBar} name="Customer Aging Summary"/>
        <MyLink path="/employees-dashboard" iconname={faUserTie} name="Employee"/>
        <MyLink path="/medical-assessments-dashboard" iconname={faBoxArchive} name="Medical Assessments"/>
        <MyLink path="/patients-dashboard" iconname={faPersonBooth} name="Patients"/>
        <MyLink path="/lab" iconname={faHouseMedical} name="Lab"/>
        <MyLink path="/reports-dashboard" iconname={faChartBar} name="Reports"/>
        <MyLink path="/reports" iconname={faCogs} name="Reports Configuration"/>
        <MyLink path="/employee-access-codes" iconname={faKey} name="Employee Access Codes"/>
      </div>
    </div>
  );
};

export default LandingPage;
